import React from "react";
import ErrorComponent from "./ErrorComponent";
import { ShowDialog } from "./showDialog";

export default class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: { message: "", stack: "" },
    info: { componentStack: "" }
  };

  static getDerivedStateFromError = error => {
    return { hasError: true };
  };

  isNetworkError(error) {
    console.log(error);
    if (!error) return false;

    const msg = error.message?.toLowerCase() || "";

    return (
      msg.includes("network error") ||
      msg.includes("failed to fetch") ||
      msg.includes("failed to load") ||
      msg.includes("load failed") ||
      msg.includes("network request failed")
    );
  }

  componentDidCatch = (error, info) => {
    this.setState({ error, info });
  };

  render() {
    const { hasError, error, info } = this.state;
    const { children } = this.props;

    if (!hasError) return children;

    const isNetError = this.isNetworkError(error);

    return isNetError ? (
      <ShowDialog error={error} info={info} />
    ) : (
      <ErrorComponent error={error} info={info} />
    );
  }
}

